var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { ApplicationEnum, CHAT_ACTIVITY_BREAKDOWN_KEYS, DRIVE_ACTIONS_OVER_TIME_KEYS, GeminiAppNameEnum, GeminiUsageCategoryEnum, GeminiUsageLevelEnum, GMAIL_ACTIONS_OVER_TIME_KEYS, GmailAnalyticsEnum, MeetEventActionEnum, MeetTimelineEventEnum } from '@workalizer/shared';
var requiredEnvVars = ['REACT_APP_GOOGLE_CLIENT_ID', 'REACT_APP_API_URL'];
requiredEnvVars.forEach(function (envVar) {
    if (process.env.NODE_ENV === 'test') {
        return;
    }
    if (!process.env[envVar]) {
        throw new Error("Missing required environment variable: ".concat(envVar));
    }
});
var env = process.env;
export var GOOGLE_CLIENT_ID = env.REACT_APP_GOOGLE_CLIENT_ID;
export var API_URL = env.REACT_APP_API_URL;
export var ENVIRONMENT = env.NODE_ENV;
export var IS_DEV = ENVIRONMENT === 'development';
export var IS_DEMO = env.REACT_APP_IS_DEMO === 'true';
export var SENTRY_AUTH_TOKEN = env.REACT_APP_SENTRY_AUTH_TOKEN;
export var SENTRY_DSN = env.REACT_APP_SENTRY_DSN;
export var GTM_ID = env.REACT_APP_GTM_ID;
export var CHART_COLORS = [
    'widgetBlue-500',
    'widgetGreen-500',
    'widgetRed-500',
    'widgetYellow-500',
    'violet-400',
    'widgetBlue-300',
    'widgetGreen-300',
    'widgetRed-300',
    'widgetYellow-300',
    'widgetYellow-400',
    'purple-400',
    'indigo-400',
    'teal-400',
    'pink-400',
    'orange-400',
    'cyan-400',
    'lime-400',
    'fuchsia-400',
    'slate-400',
    'zinc-400',
    'neutral-400',
    'stone-400',
    'widgetRed-400',
    'widgetBlue-400',
    'widgetGreen-400',
    'purple-500'
];
export var CHART_COLOR_TOKEN_HEX = {
    'widgetBlue-500': '#3578C8',
    'widgetGreen-500': '#0F9D6B',
    'widgetRed-500': '#F63939',
    'widgetYellow-500': '#E7B928',
    'violet-400': '#a78bfa',
    'widgetBlue-300': '#6F9FD6',
    'widgetGreen-300': '#5BC49B',
    'widgetRed-300': '#F28B8B',
    'widgetYellow-300': '#EFD98A',
    'widgetYellow-400': '#EED272',
    'purple-400': '#c084fc',
    'indigo-400': '#818cf8',
    'teal-400': '#2dd4bf',
    'pink-400': '#f472b6',
    'orange-400': '#fb923c',
    'orange-300': '#fdba74',
    'cyan-400': '#22d3ee',
    'lime-400': '#a3e635',
    'fuchsia-400': '#e879f9',
    'slate-400': '#94a3b8',
    'zinc-400': '#a1a1aa',
    'neutral-400': '#a3a3a3',
    'stone-400': '#a8a29e',
    'widgetRed-400': '#E77777',
    'widgetBlue-400': '#79A6DA',
    'widgetGreen-400': '#51BB8C',
    'purple-500': '#a855f7',
    'gray-300': '#d1d5db'
};
export var GMAIL_COLORS = (_a = {},
    _a[GmailAnalyticsEnum.GMAIL_EMAIL_SENT] = 'widgetGreen-500',
    _a[GmailAnalyticsEnum.GMAIL_EMAIL_RECEIVED] = 'widgetBlue-500',
    _a);
export var MEETING_LOAD_COLORS_CONFIG = {
    meetingCount: {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        translationKey: 'meetingCount'
    },
    durationSeconds: {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        translationKey: 'duration'
    },
    manHoursSeconds: {
        color: 'bg-widgetRed-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-500'],
        translationKey: 'manHours'
    },
    avgParticipants: {
        color: 'bg-orange-400',
        chartColor: CHART_COLOR_TOKEN_HEX['orange-400'],
        translationKey: 'avgParticipants'
    }
};
export var GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG = {
    sent: {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-400'],
        translationKey: 'sent'
    },
    received: {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-400'],
        translationKey: 'received'
    },
    opened: {
        color: 'bg-widgetYellow-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-400'],
        translationKey: 'opened'
    },
    replied: {
        color: 'bg-widgetRed-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-400'],
        translationKey: 'replied'
    },
    linkClicked: {
        color: 'bg-purple-500',
        chartColor: CHART_COLOR_TOKEN_HEX['purple-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['purple-400'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['purple-400'],
        translationKey: 'linkClicked'
    },
    otherEvents: {
        color: 'bg-teal-400',
        chartColor: CHART_COLOR_TOKEN_HEX['teal-400'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['cyan-400'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['teal-400'],
        translationKey: 'otherEvents'
    }
};
export var GMAIL_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS = {
    previous: GMAIL_ACTIONS_OVER_TIME_KEYS.map(function (key) { return ({
        dataKey: "previous".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG[key].prevChartColor,
        stackId: '1'
    }); }),
    current: GMAIL_ACTIONS_OVER_TIME_KEYS.map(function (key) { return ({
        dataKey: "current".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG[key].chartColor,
        stackId: '2'
    }); }),
    team: GMAIL_ACTIONS_OVER_TIME_KEYS.map(function (key) { return ({
        dataKey: "team".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: GMAIL_ACTIONS_OVER_TIME_COLORS_CONFIG[key].teamChartColor,
        stackId: '3'
    }); })
};
export var EMAIL_SUMMARY_REPLY_RATE_COLORS_CONFIG = {
    received: {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        translationKey: 'received'
    },
    opened: {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        translationKey: 'opened'
    },
    replied: {
        color: 'bg-widgetRed-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-500'],
        translationKey: 'replied'
    }
};
export var DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG = {
    created: {
        color: 'bg-purple-400',
        chartColor: CHART_COLOR_TOKEN_HEX['purple-400'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['violet-400'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['purple-400'],
        translationKey: 'created'
    },
    edited: {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-400'],
        translationKey: 'edited'
    },
    viewed: {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-400'],
        translationKey: 'viewed'
    },
    commentsPosted: {
        color: 'bg-widgetRed-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-400'],
        translationKey: 'commentsPosted'
    },
    suggestionsPosted: {
        color: 'bg-widgetYellow-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-400'],
        translationKey: 'suggestionsPosted'
    },
    otherEvents: {
        color: 'bg-orange-400',
        chartColor: CHART_COLOR_TOKEN_HEX['orange-400'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['orange-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['orange-400'],
        translationKey: 'otherEvents'
    }
};
export var DRIVE_ACTIONS_OVER_TIME_BAR_CHART_CONFIGS = {
    previous: DRIVE_ACTIONS_OVER_TIME_KEYS.map(function (key) { return ({
        dataKey: "previous".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG[key].prevChartColor,
        stackId: '1'
    }); }),
    current: DRIVE_ACTIONS_OVER_TIME_KEYS.map(function (key) { return ({
        dataKey: "current".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG[key].chartColor,
        stackId: '2'
    }); }),
    team: DRIVE_ACTIONS_OVER_TIME_KEYS.map(function (key) { return ({
        dataKey: "team".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: DRIVE_ACTIONS_OVER_TIME_COLORS_CONFIG[key].teamChartColor,
        stackId: '3'
    }); })
};
export var DRIVE_DAILY_TIMELINE_LEGEND_KEYS = [
    'created',
    'edits',
    'upload',
    'views',
    'prints',
    'downloads',
    'commentsPosted',
    'suggestionsPosted',
    'suggestionsResolved',
    'approvalRequested',
    'sharedInternally',
    'sharedExternally',
    'sharedPublicly'
];
export var DRIVE_DAILY_TIMELINE_COLORS_CONFIG = {
    created: {
        color: 'purple-400',
        hoverColor: 'hover:bg-purple-500'
    },
    edits: {
        color: 'widgetBlue-500',
        hoverColor: 'hover:bg-widgetBlue-600'
    },
    upload: {
        color: 'indigo-400',
        hoverColor: 'hover:bg-indigo-500'
    },
    views: {
        color: 'slate-400',
        hoverColor: 'hover:bg-slate-500'
    },
    prints: {
        color: 'widgetYellow-500',
        hoverColor: 'hover:bg-widgetYellow-600'
    },
    downloads: {
        color: 'widgetGreen-500',
        hoverColor: 'hover:bg-widgetGreen-600'
    },
    commentsPosted: {
        color: 'teal-400',
        hoverColor: 'hover:bg-teal-500'
    },
    suggestionsPosted: {
        color: 'fuchsia-400',
        hoverColor: 'hover:bg-fuchsia-500'
    },
    suggestionsResolved: {
        color: 'pink-400',
        hoverColor: 'hover:bg-pink-500'
    },
    approvalRequested: {
        color: 'orange-400',
        hoverColor: 'hover:bg-orange-500'
    },
    sharedInternally: {
        color: 'cyan-400',
        hoverColor: 'hover:bg-cyan-500'
    },
    sharedExternally: {
        color: 'widgetRed-300',
        hoverColor: 'hover:bg-widgetRed-400'
    },
    sharedPublicly: {
        color: 'widgetRed-500',
        hoverColor: 'hover:bg-widgetRed-600'
    }
};
export var CHAT_ACTIVITY_BREAKDOWN_COLORS_CONFIG = {
    messagesSent: {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        translationKey: 'messagesSent'
    },
    reactionsSent: {
        color: 'bg-widgetGreen-300',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-300'],
        translationKey: 'reactionsSent'
    },
    messagesReceived: {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        translationKey: 'messagesReceived'
    },
    reactionsReceived: {
        color: 'bg-widgetBlue-300',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300'],
        translationKey: 'reactionsReceived'
    }
};
export var CHAT_ACTIVITY_BREAKDOWN_BAR_CHART_CONFIGS = {
    sent: CHAT_ACTIVITY_BREAKDOWN_KEYS.filter(function (key) { return key.endsWith('Sent'); }).map(function (key) { return ({
        dataKey: key,
        fill: CHAT_ACTIVITY_BREAKDOWN_COLORS_CONFIG[key].chartColor,
        stackId: 'sent'
    }); }),
    received: CHAT_ACTIVITY_BREAKDOWN_KEYS.filter(function (key) {
        return key.endsWith('Received');
    }).map(function (key) { return ({
        dataKey: key,
        fill: CHAT_ACTIVITY_BREAKDOWN_COLORS_CONFIG[key].chartColor,
        stackId: 'received'
    }); })
};
export var ACTIVITY_COLORS = (_b = {},
    _b[ApplicationEnum.MEET] = {
        color: 'widgetBlue-500',
        hoverColor: 'hover:bg-widgetBlue-600',
        colorsList: [
            'widgetBlue-100',
            'widgetBlue-200',
            'widgetBlue-300',
            'widgetBlue-400',
            'widgetBlue-500',
            'widgetBlue-600',
            'widgetBlue-700',
            'widgetBlue-800',
            'widgetBlue-900'
        ]
    },
    _b[ApplicationEnum.CHAT] = {
        color: 'widgetGreen-500',
        hoverColor: 'hover:bg-widgetGreen-600',
        colorsList: [
            'widgetGreen-100',
            'widgetGreen-200',
            'widgetGreen-300',
            'widgetGreen-400',
            'widgetGreen-500',
            'widgetGreen-600',
            'widgetGreen-700',
            'widgetGreen-800',
            'widgetGreen-900'
        ]
    },
    _b[ApplicationEnum.GMAIL] = {
        color: 'widgetRed-500',
        hoverColor: 'hover:bg-widgetRed-600',
        colorsList: [
            'widgetRed-100',
            'widgetRed-200',
            'widgetRed-300',
            'widgetRed-400',
            'widgetRed-500',
            'widgetRed-600',
            'widgetRed-700',
            'widgetRed-800',
            'widgetRed-900'
        ]
    },
    _b[ApplicationEnum.DRIVE] = {
        color: 'widgetYellow-500',
        hoverColor: 'hover:bg-widgetYellow-700',
        colorsList: [
            'widgetYellow-100',
            'widgetYellow-200',
            'widgetYellow-300',
            'widgetYellow-400',
            'widgetYellow-500',
            'widgetYellow-600',
            'widgetYellow-700',
            'widgetYellow-800',
            'widgetYellow-900'
        ]
    },
    _b[ApplicationEnum.GEMINI] = {
        color: 'purple-400',
        hoverColor: 'hover:bg-purple-500',
        colorsList: [
            'purple-100',
            'purple-200',
            'purple-300',
            'purple-400',
            'purple-500',
            'purple-600',
            'purple-700',
            'purple-800',
            'purple-900'
        ]
    },
    _b[ApplicationEnum.CALENDAR] = {
        color: 'widgetBlue-300',
        hoverColor: 'hover:bg-widgetBlue-400',
        colorsList: [
            'widgetBlue-100',
            'widgetBlue-200',
            'widgetBlue-300',
            'widgetBlue-400',
            'widgetBlue-500',
            'widgetBlue-600',
            'widgetBlue-700',
            'widgetBlue-800',
            'widgetBlue-900'
        ]
    },
    _b);
export var MEET_USERS_TIMELINE_COLORS = (_c = {},
    _c[MeetTimelineEventEnum.MEET_CALL_STARTED] = 'bg-widgetGreen-500 hover:bg-widgetGreen-600',
    _c[MeetEventActionEnum.MEET_CALL_ENDED] = 'bg-widgetRed-500 hover:bg-widgetRed-600',
    _c[MeetEventActionEnum.MEET_PRESENTATION_STARTED] = 'bg-widgetBlue-500 hover:bg-widgetBlue-600',
    _c[MeetEventActionEnum.MEET_PRESENTATION_STOPPED] = 'bg-widgetBlue-300 hover:bg-widgetBlue-400',
    _c[MeetEventActionEnum.MEET_KNOCKING_ACCEPTED] = 'bg-widgetYellow-500 hover:bg-widgetYellow-600',
    _c[MeetEventActionEnum.MEET_KNOCKING_DENIED] = 'bg-widgetYellow-300 hover:bg-widgetYellow-400',
    _c[MeetEventActionEnum.MEET_TRANSCRIPTION_ACTIVITY] = 'bg-purple-500 hover:bg-purple-600',
    _c[MeetEventActionEnum.MEET_RECORDING_ACTIVITY] = 'bg-indigo-500 hover:bg-indigo-600',
    _c);
export var FILTER_PERIOD_OPTIONS = [
    { id: 'week', name: 'Week' },
    { id: 'month', name: 'Month' },
    { id: '3month', name: '3 Months' },
    { id: '6month', name: '6 Months' },
    { id: 'year', name: 'Year' },
    { id: 'custom', name: 'Custom' }
];
export var TablesDiffColorsConfig = {
    GREEN: 'widgetGreen',
    BLUE: 'widgetBlue',
    INTENSITY: '500'
};
export var WIDGET_LINE_CHART_GREEN = "".concat(TablesDiffColorsConfig.GREEN, "-").concat(TablesDiffColorsConfig.INTENSITY);
export var COMMUNICATION_BY_WEEKDAYS_CONFIG = {
    meetings: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        teamChartColor: '#51BB8C',
        translationKey: 'Meetings'
    },
    docs: {
        color: 'bg-widgetYellow-300',
        chartColor: '#E7B928',
        prevChartColor: '#EFD98A',
        teamChartColor: '#EED272',
        translationKey: 'Docs'
    },
    chat: {
        color: 'bg-widgetBlue-500',
        chartColor: '#3578C8',
        prevChartColor: '#6F9FD6',
        teamChartColor: '#79A6DA',
        translationKey: 'Chat'
    },
    emails: {
        color: 'bg-widgetRed-500',
        chartColor: '#F63939',
        prevChartColor: '#F28B8B',
        teamChartColor: '#E77777',
        translationKey: 'Emails'
    }
};
export var COLLABORATIVE_CONFIG = {
    team: {
        meetings: {
            color: 'bg-widgetGreen-500',
            chartColor: '#0F9D6B',
            translationKey: 'teamMeetings'
        },
        chats: {
            color: 'bg-widgetGreen-300',
            chartColor: '#5BC49B',
            translationKey: 'teamChats'
        },
        gmails: {
            color: 'bg-widgetGreen-400',
            chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-400'],
            translationKey: 'teamGmail',
            striped: true
        }
    },
    crossTeam: {
        meetings: {
            color: 'bg-widgetBlue-500',
            chartColor: '#3578C8',
            translationKey: 'crossTeamMeetings'
        },
        chats: {
            color: 'bg-widgetBlue-300',
            chartColor: '#6F9FD6',
            translationKey: 'crossTeamChats'
        },
        gmails: {
            color: 'bg-widgetBlue-400',
            chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-400'],
            translationKey: 'crossTeamGmail',
            striped: true
        }
    },
    external: {
        meetings: {
            color: 'bg-widgetRed-500',
            chartColor: '#F63939',
            translationKey: 'externalMeetings'
        },
        chats: {
            color: 'bg-widgetRed-300',
            chartColor: '#F28B8B',
            translationKey: 'externalChats'
        },
        gmails: {
            color: 'bg-widgetRed-400',
            chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-400'],
            translationKey: 'externalGmail',
            striped: true
        }
    }
};
export var DOC_REVIEW_CONFIG = {
    approved: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        teamChartColor: '#51BB8C',
        translationKey: 'approvedSuggestions'
    },
    rejected: {
        color: 'bg-widgetBlue-500',
        chartColor: '#3578C8',
        prevChartColor: '#6F9FD6',
        teamChartColor: '#79A6DA',
        translationKey: 'rejectedSuggestions'
    }
};
export var MEETING_ATTENDANCE_CONFIG = {
    attended: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        teamChartColor: '#51BB8C',
        translationKey: 'attendedMeetings'
    },
    missed: {
        color: 'bg-white border-widgetGreen-500',
        chartColor: '#F63939',
        strokeColor: '#FFFFFF',
        prevChartColor: '#F28B8B',
        prevStrokeColor: '#FFFFFF',
        teamChartColor: '#E77777',
        translationKey: 'missedMeetings'
    },
    minBarHeight: 300
};
export var WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG = {
    workDay: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        translationKey: 'workDay'
    },
    teamAverageWorkDay: {
        color: 'bg-widgetGreen-400',
        chartColor: '#51BB8C',
        translationKey: 'teamAverageWorkDay'
    }
};
export var WORK_LOCATION_BREAKDOWN_CONFIG = {
    office: {
        color: 'bg-widgetGreen-500',
        currentPeriodColor: '#0F9D6B',
        previousPeriodColor: '#5BC49B',
        teamAverageColor: '#51BB8C',
        translationKey: 'officeWork'
    },
    remote: {
        color: 'bg-widgetBlue-500',
        currentPeriodColor: '#3578C8',
        previousPeriodColor: '#6F9FD6',
        teamAverageColor: '#79A6DA',
        translationKey: 'remoteWork'
    }
};
export var PLANNED_VS_AD_HOC_MEETING_CONFIG = {
    planned: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        teamChartColor: '#51BB8C',
        translationKey: 'plannedMeetings'
    },
    adhoc: {
        color: 'bg-widgetBlue-500',
        chartColor: '#3578C8',
        prevChartColor: '#6F9FD6',
        teamChartColor: '#79A6DA',
        translationKey: 'adhocMeetings'
    }
};
export var CREATED_AND_OWNED_FILES_CONFIG = {
    createdAndOwnedFiles: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        translationKey: 'createdAndOwnedFiles'
    },
    previousPeriod: {
        color: 'bg-widgetGreen-300',
        chartColor: '#5BC49B',
        translationKey: 'previousPeriod'
    },
    teamAverage: {
        color: 'bg-widgetGreen-400',
        chartColor: '#51BB8C',
        translationKey: 'teamAverage'
    }
};
export var SHARED_FILES_CONFIG = {
    internalSharing: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        translationKey: 'internalSharing'
    },
    externalSharing: {
        color: 'bg-widgetBlue-500',
        chartColor: '#3578C8',
        prevChartColor: '#6F9FD6',
        translationKey: 'externalSharing'
    },
    internalSharingTeam: {
        color: 'bg-widgetGreen-400',
        chartColor: '#51BB8C',
        translationKey: 'internalSharingTeam'
    },
    externalSharingTeam: {
        color: 'bg-widgetBlue-400',
        chartColor: '#79A6DA',
        translationKey: 'externalSharingTeam'
    }
};
export var TIME_SPENT_ON_ACTIVITIES_KEYS = [
    'docsCommentsPosted',
    'meetingsOrganized',
    'chatMessagesSent',
    'emailsSent'
];
export var TIME_SPENT_ON_ACTIVITIES_COLORS_CONFIG = {
    docsCommentsPosted: {
        color: 'bg-widgetYellow-500',
        chartColor: '#E7B928',
        prevChartColor: '#EFD98A',
        teamChartColor: '#EED272'
    },
    meetingsOrganized: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        teamChartColor: '#51BB8C'
    },
    chatMessagesSent: {
        color: 'bg-widgetBlue-500',
        chartColor: '#3578C8',
        prevChartColor: '#6F9FD6',
        teamChartColor: '#79A6DA'
    },
    emailsSent: {
        color: 'bg-widgetRed-500',
        chartColor: '#F63939',
        prevChartColor: '#F28B8B',
        teamChartColor: '#E77777'
    }
};
export var TIME_SPENT_ON_ACTIVITIES_BAR_CHART_CONFIGS = {
    previous: TIME_SPENT_ON_ACTIVITIES_KEYS.map(function (key) { return ({
        dataKey: "previous".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: TIME_SPENT_ON_ACTIVITIES_COLORS_CONFIG[key].prevChartColor,
        stackId: 'prev'
    }); }),
    current: TIME_SPENT_ON_ACTIVITIES_KEYS.map(function (key) { return ({
        dataKey: "current".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: TIME_SPENT_ON_ACTIVITIES_COLORS_CONFIG[key].chartColor,
        stackId: 'curr'
    }); }),
    team: TIME_SPENT_ON_ACTIVITIES_KEYS.map(function (key) { return ({
        dataKey: "team".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: TIME_SPENT_ON_ACTIVITIES_COLORS_CONFIG[key].teamChartColor,
        stackId: 'team'
    }); })
};
export var TIME_SPENT_ON_WORK_ACTIVITIES_USER_CONFIG = {
    previous: {
        color: 'bg-widgetBlue-300',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300'],
        translationKey: 'previous'
    },
    current: {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        translationKey: 'current'
    },
    teamAverage: {
        color: 'bg-widgetBlue-400',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-400'],
        translationKey: 'teamAverage'
    }
};
export var TIME_SPENT_ON_WORK_ACTIVITIES_ENTITY_CHART_COLORS = [
    {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300']
    },
    {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-300']
    },
    {
        color: 'bg-widgetRed-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-300']
    },
    {
        color: 'bg-widgetYellow-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-300']
    },
    {
        color: 'bg-violet-400',
        chartColor: CHART_COLOR_TOKEN_HEX['violet-400'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['purple-400']
    },
    {
        color: 'bg-orange-400',
        chartColor: CHART_COLOR_TOKEN_HEX['orange-400'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['orange-300']
    },
    {
        color: 'bg-cyan-400',
        chartColor: CHART_COLOR_TOKEN_HEX['cyan-400'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300']
    },
    {
        color: 'bg-pink-400',
        chartColor: CHART_COLOR_TOKEN_HEX['pink-400'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-300']
    }
];
export var TIME_SPENT_BY_ACTIVITY_TYPE_KEYS = [
    'communication',
    'meetings',
    'scheduledTime',
    'documentWork',
    'aiActivity'
];
var timeSpentByActivityTypeColorEntry = function (app) {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = ACTIVITY_COLORS[app], color = _h.color, colorsList = _h.colorsList;
    var prevToken = (_a = colorsList[3]) !== null && _a !== void 0 ? _a : color.replace('-500', '-400');
    var teamToken = (_b = colorsList[4]) !== null && _b !== void 0 ? _b : color.replace('-500', '-400');
    return {
        color: "bg-".concat(color),
        chartColor: (_c = CHART_COLOR_TOKEN_HEX[color]) !== null && _c !== void 0 ? _c : '#94a3b8',
        prevChartColor: (_e = (_d = CHART_COLOR_TOKEN_HEX[prevToken]) !== null && _d !== void 0 ? _d : CHART_COLOR_TOKEN_HEX[color]) !== null && _e !== void 0 ? _e : '#94a3b8',
        teamChartColor: (_g = (_f = CHART_COLOR_TOKEN_HEX[teamToken]) !== null && _f !== void 0 ? _f : CHART_COLOR_TOKEN_HEX[color.replace('-500', '-400')]) !== null && _g !== void 0 ? _g : '#94a3b8'
    };
};
export var TIME_SPENT_BY_ACTIVITY_TYPE_APP = {
    communication: ApplicationEnum.CHAT,
    meetings: ApplicationEnum.MEET,
    scheduledTime: ApplicationEnum.CALENDAR,
    documentWork: ApplicationEnum.DRIVE,
    aiActivity: ApplicationEnum.GEMINI
};
export var TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG = Object.fromEntries(TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.map(function (key) { return [
    key,
    timeSpentByActivityTypeColorEntry(TIME_SPENT_BY_ACTIVITY_TYPE_APP[key])
]; }));
export var TIME_SPENT_BY_ACTIVITY_TYPE_BAR_CHART_CONFIGS = {
    previous: TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.map(function (key) { return ({
        dataKey: "previous".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].prevChartColor,
        stackId: 'prev'
    }); }),
    current: TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.map(function (key) { return ({
        dataKey: "current".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].chartColor,
        stackId: 'curr'
    }); }),
    team: TIME_SPENT_BY_ACTIVITY_TYPE_KEYS.map(function (key) { return ({
        dataKey: "team".concat(key.charAt(0).toUpperCase() + key.slice(1)),
        fill: TIME_SPENT_BY_ACTIVITY_TYPE_COLORS_CONFIG[key].teamChartColor,
        stackId: 'team'
    }); })
};
export var SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG = {
    attended: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        teamAvgChartColor: '#51BB8C',
        translationKey: 'attendedMeetings'
    },
    skipped: {
        color: 'bg-widgetRed-500',
        chartColor: '#F63939',
        prevChartColor: '#F28B8B',
        teamAvgChartColor: '#E77777',
        translationKey: 'skippedMeetings'
    }
};
export var SCHEDULED_MEET_ATTENDANCE_CHART_CONFIG = {
    attended: {
        color: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.attended.color,
        chartColor: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.attended.chartColor,
        prevChartColor: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.attended.prevChartColor,
        translationKey: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.attended.translationKey
    },
    missed: {
        color: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.skipped.color,
        chartColor: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.skipped.chartColor,
        strokeColor: '#FFFFFF',
        prevChartColor: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.skipped.prevChartColor,
        prevStrokeColor: '#FFFFFF',
        translationKey: SCHEDULED_MEET_ATTENDANCE_RATE_COLORS_CONFIG.skipped.translationKey
    },
    minBarHeight: MEETING_ATTENDANCE_CONFIG.minBarHeight
};
export var EXTENDED_WORK_HOURS_HEATMAP_COLORS = [
    { id: 1, color: 'text-widgetGreen-500' },
    { id: 2, color: 'text-widgetGreen-500' },
    { id: 3, color: 'text-widgetGreen-500' },
    { id: 4, color: 'text-widgetGreen-500' },
    { id: 5, color: 'text-widgetGreen-500' },
    { id: 6, color: 'text-widgetGreen-500' },
    { id: 7, color: 'text-widgetGreen-500' },
    { id: 8, color: 'text-widgetGreen-500' },
    { id: 9, color: 'text-widgetRed-200' },
    { id: 10, color: 'text-widgetRed-300' },
    { id: 11, color: 'text-widgetRed-400' },
    { id: 12, color: 'text-widgetRed-700' },
    { id: 13, color: 'text-widgetRed-900' },
    { id: 14, color: 'text-widgetRed-900' }
];
export var BREAKS_DURING_WORK_INDICATOR_HEATMAP_COLORS = [
    { id: 1, color: 'text-widgetBlue-100' },
    { id: 2, color: 'text-widgetBlue-200' },
    { id: 3, color: 'text-widgetBlue-300' },
    { id: 4, color: 'text-widgetBlue-400' },
    { id: 5, color: 'text-widgetBlue-600' },
    { id: 6, color: 'text-widgetBlue-700' },
    { id: 7, color: 'text-widgetBlue-900' }
];
export var NUMBER_OF_DOCS_EXTERNALLY_SHARED_COLORS_CONFIG = {
    docsSharedExternally: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        translationKey: 'docsSharedExternally'
    },
    previousPeriod: {
        color: 'bg-widgetGreen-300',
        chartColor: '#5BC49B',
        translationKey: 'previousPeriod'
    },
    teamAverage: {
        color: 'bg-widgetGreen-400',
        chartColor: '#51BB8C',
        translationKey: 'teamAverage'
    }
};
export var MANAGER_INDIVIDUAL_COMM_TIME_COLORS_CONFIG = {
    meet: {
        color: 'bg-widgetGreen-500',
        chartColor: '#0F9D6B',
        prevChartColor: '#5BC49B',
        translationKey: 'meetings'
    },
    chat: {
        color: 'bg-widgetBlue-500',
        chartColor: '#3578C8',
        prevChartColor: '#6F9FD6',
        translationKey: 'chat'
    }
};
export var WORKING_TIME_ALLOCATION_BY_LABEL_COLORS = {
    labels: ['#F63939', '#3578C8', '#E7B928', '#0F9D6B'],
    uncategorized: '#BDBDBD'
};
export var GEMINI_USAGE_LEVEL_COLORS_CONFIG = (_d = {},
    _d[GeminiUsageLevelEnum.ZERO] = {
        color: 'bg-slate-300',
        chartColor: '#cbd5e1',
        prevChartColor: '#e2e8f0',
        teamChartColor: '#94a3b8',
        translationKey: 'zero'
    },
    _d[GeminiUsageLevelEnum.LOW] = {
        color: 'bg-widgetRed-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-400'],
        translationKey: 'low'
    },
    _d[GeminiUsageLevelEnum.MEDIUM] = {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-400'],
        translationKey: 'medium'
    },
    _d[GeminiUsageLevelEnum.HIGH] = {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-400'],
        translationKey: 'high'
    },
    _d);
export var GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS = (_e = {},
    _e[GeminiUsageCategoryEnum.CHAT_AND_RESEARCH] = 'chatAndResearch',
    _e[GeminiUsageCategoryEnum.CONTENT_CREATION] = 'contentCreation',
    _e[GeminiUsageCategoryEnum.SUMMARIZE] = 'summarize',
    _e[GeminiUsageCategoryEnum.WORKFLOW_ACTIONS] = 'workflowActions',
    _e);
export var GEMINI_USAGE_CATEGORY_COLORS_CONFIG = (_f = {},
    _f[GeminiUsageCategoryEnum.CHAT_AND_RESEARCH] = {
        color: 'bg-widgetGreen-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetGreen-400']
    },
    _f[GeminiUsageCategoryEnum.CONTENT_CREATION] = {
        color: 'bg-widgetBlue-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetBlue-400']
    },
    _f[GeminiUsageCategoryEnum.SUMMARIZE] = {
        color: 'bg-widgetRed-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetRed-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetRed-400']
    },
    _f[GeminiUsageCategoryEnum.WORKFLOW_ACTIONS] = {
        color: 'bg-widgetYellow-500',
        chartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-500'],
        prevChartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-300'],
        teamChartColor: CHART_COLOR_TOKEN_HEX['widgetYellow-400']
    },
    _f);
export var INVOCATIONS_BY_ACTION_COLORS_CONFIG = {
    currentPeriod: (_g = {},
        _g[GeminiAppNameEnum.GMAIL] = {
            color: 'bg-widgetBlue-500',
            chartColor: '#3578C8',
            translationKey: 'gmail'
        },
        _g[GeminiAppNameEnum.DRIVE] = {
            color: 'bg-orange-400',
            chartColor: '#F28E2B',
            translationKey: 'drive'
        },
        _g[GeminiAppNameEnum.DOCS] = {
            color: 'bg-widgetGreen-500',
            chartColor: '#0F9D6B',
            translationKey: 'docs'
        },
        _g[GeminiAppNameEnum.SHEETS] = {
            color: 'bg-widgetRed-500',
            chartColor: '#F63939',
            translationKey: 'sheets'
        },
        _g[GeminiAppNameEnum.SLIDES] = {
            color: 'bg-violet-400',
            chartColor: '#8E7CA8',
            translationKey: 'slides'
        },
        _g[GeminiAppNameEnum.MEET] = {
            color: 'bg-teal-500',
            chartColor: '#76B7B2',
            translationKey: 'meet'
        },
        _g[GeminiAppNameEnum.CHAT] = {
            color: 'bg-widgetYellow-500',
            chartColor: '#E7B928',
            translationKey: 'chat'
        },
        _g[GeminiAppNameEnum.CLASSROOM] = {
            color: 'bg-widgetRed-500',
            chartColor: '#F63939',
            translationKey: 'classroom'
        },
        _g[GeminiAppNameEnum.KEEP] = {
            color: 'bg-lime-600',
            chartColor: '#8C8C3C',
            translationKey: 'keep'
        },
        _g[GeminiAppNameEnum.VIDS] = {
            color: 'bg-neutral-400',
            chartColor: '#8A8A8A',
            translationKey: 'vids'
        },
        _g[GeminiAppNameEnum.GEMINI_APP] = {
            color: 'bg-indigo-500',
            chartColor: '#6B5B95',
            translationKey: 'geminiApp'
        },
        _g),
    previousPeriod: (_h = {},
        _h[GeminiAppNameEnum.GMAIL] = {
            color: 'bg-widgetBlue-300',
            chartColor: '#6F9FD6',
            translationKey: 'gmail'
        },
        _h[GeminiAppNameEnum.DRIVE] = {
            color: 'bg-orange-300',
            chartColor: '#F7BB80',
            translationKey: 'drive'
        },
        _h[GeminiAppNameEnum.DOCS] = {
            color: 'bg-widgetGreen-300',
            chartColor: '#5BC49B',
            translationKey: 'docs'
        },
        _h[GeminiAppNameEnum.SHEETS] = {
            color: 'bg-widgetRed-300',
            chartColor: '#F28B8B',
            translationKey: 'sheets'
        },
        _h[GeminiAppNameEnum.SLIDES] = {
            color: 'bg-violet-200',
            chartColor: '#BBB0CB',
            translationKey: 'slides'
        },
        _h[GeminiAppNameEnum.MEET] = {
            color: 'bg-teal-200',
            chartColor: '#9BCDC9',
            translationKey: 'meet'
        },
        _h[GeminiAppNameEnum.CHAT] = {
            color: 'bg-widgetYellow-300',
            chartColor: '#EFD98A',
            translationKey: 'chat'
        },
        _h[GeminiAppNameEnum.CLASSROOM] = {
            color: 'bg-widgetRed-300',
            chartColor: '#F28B8B',
            translationKey: 'classroom'
        },
        _h[GeminiAppNameEnum.KEEP] = {
            color: 'bg-amber-100',
            chartColor: '#BABA8A',
            translationKey: 'keep'
        },
        _h[GeminiAppNameEnum.VIDS] = {
            color: 'bg-neutral-400',
            chartColor: '#B9B9B9',
            translationKey: 'vids'
        },
        _h[GeminiAppNameEnum.GEMINI_APP] = {
            color: 'bg-indigo-200',
            chartColor: '#A899C6',
            translationKey: 'geminiApp'
        },
        _h),
    team: (_j = {},
        _j[GeminiAppNameEnum.GMAIL] = {
            color: 'bg-widgetBlue-400',
            chartColor: '#79A6DA',
            translationKey: 'gmail'
        },
        _j[GeminiAppNameEnum.DRIVE] = {
            color: 'bg-orange-200',
            chartColor: '#FBDDBF',
            translationKey: 'drive'
        },
        _j[GeminiAppNameEnum.DOCS] = {
            color: 'bg-widgetGreen-400',
            chartColor: '#51BB8C',
            translationKey: 'docs'
        },
        _j[GeminiAppNameEnum.SHEETS] = {
            color: 'bg-widgetRed-400',
            chartColor: '#E77777',
            translationKey: 'sheets'
        },
        _j[GeminiAppNameEnum.SLIDES] = {
            color: 'bg-violet-100',
            chartColor: '#DDD8E5',
            translationKey: 'slides'
        },
        _j[GeminiAppNameEnum.MEET] = {
            color: 'bg-teal-100',
            chartColor: '#C1E2DF',
            translationKey: 'meet'
        },
        _j[GeminiAppNameEnum.CHAT] = {
            color: 'bg-widgetYellow-400',
            chartColor: '#EED272',
            translationKey: 'chat'
        },
        _j[GeminiAppNameEnum.CLASSROOM] = {
            color: 'bg-widgetRed-400',
            chartColor: '#E77777',
            translationKey: 'classroom'
        },
        _j[GeminiAppNameEnum.KEEP] = {
            color: 'bg-widgetYellow-100',
            chartColor: '#EED272',
            translationKey: 'keep'
        },
        _j[GeminiAppNameEnum.VIDS] = {
            color: 'bg-neutral-300',
            chartColor: '#DCDCDC',
            translationKey: 'vids'
        },
        _j[GeminiAppNameEnum.GEMINI_APP] = {
            color: 'bg-indigo-100',
            chartColor: '#C9BFE0',
            translationKey: 'geminiApp'
        },
        _j)
};
export var PAGINATION_PAGE_SIZE = 10;
export var EVENTS_LOG_PAGE_SIZE = 50;
export var WORK_LOCATION_BREAKDOWN_COLORS_CONFIG = {
    currentPeriod: {
        officeWork: {
            color: 'bg-widgetGreen-500',
            chartColor: '#0F9D6B',
            translationKey: 'officeWork'
        },
        remoteWork: {
            color: 'bg-widgetBlue-500',
            chartColor: '#3578C8',
            translationKey: 'remoteWork'
        }
    },
    previousPeriod: {
        officeWork: {
            color: 'bg-widgetGreen-300',
            chartColor: '#5BC49B',
            translationKey: 'officeWork'
        },
        remoteWork: {
            color: 'bg-widgetBlue-300',
            chartColor: '#6F9FD6',
            translationKey: 'remoteWork'
        }
    },
    teamAverage: {
        officeWork: {
            color: 'bg-widgetGreen-400',
            chartColor: '#51BB8C',
            translationKey: 'officeWork'
        },
        remoteWork: {
            color: 'bg-widgetBlue-400',
            chartColor: '#79A6DA',
            translationKey: 'remoteWork'
        }
    }
};
export var RECHARTS_STACK_BAR_WHITE_STROKE = {
    stroke: '#fff',
    strokeWidth: 2
};
export var BAR_CHART_SMALL_BAR_GROUP_THRESHOLD = 9;
export var BAR_CHART_BAR_LAYOUT = {
    '1-normal': { barGap: 6, barSize: 35 },
    '1-small': { barGap: 3, barSize: 30 },
    '2-normal': { barGap: 6, barSize: 35 },
    '2-small': { barGap: 3, barSize: 20 },
    '3-normal': { barGap: 5, barSize: 30 },
    '3-small': { barGap: 3, barSize: 15 }
};
